import React, { useState, useEffect } from 'react';
import * as IdKey from 'short-uuid';
import {
    Grid,
    TextField,
    FormControl,
    Typography,
    FormHelperText,
} from '@material-ui/core';

import Snackbars from '../../componentes/snackbars/SnackBars';
import ModalConfirm from '../../utils/form/modalConfirmBase';
import { createPosition, getById, getProfilePosition, updateProfile } from '../../actions/position-actions';
import MUIEditor, { MUIEditorState } from 'react-mui-draft-wysiwyg';
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import ConfirmDialog from "../../utils/form/confirmDialog";
import AlertDialog from "../../utils/form/alertDialog";
import TitleCase from "react-title-case";
import { convertToRaw, convertFromRaw } from 'draft-js';
import { rawContent } from '../../../src/actions/dummy-actions';
import { getMaestras } from '../../actions/maestras-actions';
import { useForm, Controller } from "react-hook-form";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { SelectPosition } from '../../utils/form/selectBasic';
import { ColorButton, BorderGreenButton, BorderRedButton } from "../../utils/form/buttonsForm";
import { REQUIRED_MESSAGE } from "../../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { titleCase } from "title-case";
import { styles } from '../styles';
import * as yup from "yup";
import _ from 'lodash';
import { useStateValue } from "../../context/store";

const editorConfig = {};

const CreatePosition = (props) => {
    const classes = styles();
    const { id } = props.match.params;
    const isId = id;
    const [editorState, setEditorState] = useState(
        MUIEditorState.createWithContent(
            editorConfig,
            convertFromRaw(rawContent)
        )
    );

    const initialState =
    {
        rolePosition: '',
        immediateBoss: '',
        chargesUnderSupervision: [],
        location: '',
        attribute: '',
        chargeMission: '',
        profilePosition: '',
        creationUser: 'Developer'
    }
        ;


        const [openEditConfirm, setOpenEditConfirm] = useState(false);
        const [charges, setCharges] = useState([]);
        const [location, setLocation] = useState([]);
        const [informationPosition, setInformationPosition] = useState(initialState);
        const [{filterProfile}, dispatch] = useStateValue();

    const [inputsValidation, setInputsValidation] = useState(() => {
        let values = {};
        for (const prop in informationPosition) {
            values[prop] = false;
        }
        return values;
    });
    const [maestras, setMaestras] = useState({
        jefeInmediato: [],
        motivoRetiro: [],
        motivoSolicitud: [],
        rolDecargo: [],
        tipoContrato: [],
    });

    const [confirm, setConfirm] = useState({
        open: false,
        question: "",
        handleClickOut: () => { },
        handleClick: () => { },
    });

    const [message, setMessage] = useState({
        description: '',
        textButtonSubmit: '',
        handleClick: () => { },
        handleClickOut: () => { },
        oneButtons: false,
        type: '',
        open: false
    })

    const closeMessage = () => {
        setMessage((anterior) => ({
            ...anterior,
            open: false,
        }));
    };

    const closeModal = () => {
        setConfirm((anterior) => ({
            ...anterior,
            open: false,
        }));
    };

    const cancelConfirm = () => {
        const edit = "¿Está seguro que NO desea continuar editando el registro?"
        setMessage({
            description: edit,
            textButtonSubmit: 'Aceptar',
            handleClick: () => handleClickOut(),
            handleClickOut: () => handleClickClose(),
            type: 'WARNING',
            open: true
        })
    };


    const onChangeValue = (newState) => setEditorState(newState);

    const onChangeGeneral = (e) => {
        const { name, value } = e.target;
        validateSingle(name, value);
        setInformationPosition({ ...informationPosition, [name]: value });
    };

    const validateForm = () => {

        let inputsValidationTemp = {
            rolePosition: informationPosition?.rolePosition?.trim().length === 0,
            immediateBoss: informationPosition?.immediateBoss?.trim().length === 0,
            // chargesUnderSupervision: informationPosition?.chargesUnderSupervision?.length === 0,
            location: informationPosition?.location?.trim().length === 0,
            chargeMission: informationPosition?.chargeMission?.trim().length === 0,
            profilePosition: informationPosition?.profilePosition?.trim().length === 0,
        };
        setInputsValidation(inputsValidationTemp)
        for (const prop in inputsValidationTemp) {
            if (inputsValidationTemp[prop] === true) {
                return false;
            };
        }
        return true;
    };

    const validateSingle = (nameField, flieldValue) => {

        switch (nameField) {
            case 'rolePosition': {
                setInputsValidation({ ...inputsValidation, rolePosition: flieldValue?.trim().length === 0 })
                break;
            }
            case 'immediateBoss': {
                setInputsValidation({ ...inputsValidation, immediateBoss: flieldValue?.trim().length === 0 })
                break;
            }
            case 'location': {
                setInputsValidation({ ...inputsValidation, location: flieldValue?.trim().length === 0 })
                break;
            }
            case 'chargeMission': {
                setInputsValidation({ ...inputsValidation, chargeMission: flieldValue?.trim().length === 0 })
                break;
            }
            // case 'chargesUnderSupervision': {
            //     setInputsValidation({ ...inputsValidation, chargesUnderSupervision: flieldValue?.length === 0 })
            //     break;
            // }
            case 'profilePosition': {
                setInputsValidation({ ...inputsValidation, profilePosition: flieldValue?.length === 0 })
                break;
            }
        }
    }

    const valueText = (val) => {
        let valor = JSON.parse(val) ?? rawContent;
        let newValor = { ...valor, entityMap: valor?.entitymap ?? {} }
        if (valor) {
            setEditorState(MUIEditorState.createWithContent(editorConfig, convertFromRaw(valor)
            ))
        }
    }

    const minCharacteres = informationPosition.chargeMission.length < 5 && informationPosition.chargeMission.length >= 1
    const maxCharacteres = informationPosition.chargeMission.length > 250

    useEffect(() => {
        if (isId) {
            const positionById = async () => {
                const response = await getById(isId);

                setInformationPosition(
                    {
                        rolePosition: response?.data?.rolePosition,
                        immediateBoss: response?.data?.immediateBoss?.id,
                        chargesUnderSupervision: response?.data?.chargesUnderSupervision,
                        location: response.data?.location,
                        chargeMission: response.data?.chargeMission,
                        profilePosition: response?.data?.nameProfilePosition?.id,
                        status: response?.data?.status,
                        creationUser: 'Developer'
                    })
                if (response?.data?.attribute) valueText(response?.data?.attribute)

            }
            positionById();
        }

        if (informationPosition.position?.length > 0) {
            validateForm()
        }
    }, [informationPosition.position]);

    useEffect(() => {
        const getListaCharges = async () => {
            const response = await getProfilePosition('ACTIVO');
            setCharges(_.sortBy(response?.data?.chargeList, [function (o) { return o.denomination; }]));
        };
        getListaCharges();

        const getListaLocations = async () => {
            const response = await getMaestras();
            setLocation(_.sortBy(response?.data?.maestras?.ubicaciones, [function (o) { return o }]));
        };
        getListaLocations();

        const getListaMaestras = async () => {
            const response = await getMaestras();
            setMaestras(response?.data?.maestras);
        };
        getListaMaestras();

        dispatch({
            type: "SET_BREADCRUMB",
            breadCrumbText: "Cargos   |   Cargos  >  Perfil de Cargos",
            breadCrumbSubText: "Perfil de Cargos",
            index: 6,
          });

    }, []);

    const handleClickOut = () => props.history.push('/dashboard/perfil-cargos')
    const handleClickClose = () => setMessage({ ...message, open: false });

    const onClickSave = () => {
        const edit = "¿Está seguro que desea editar el registro?";
        const isValid = validateForm();
        if (!isValid) {
            setMessage({
                description: `Hay errores en la validación del formulario, verifique nuevamente`,
                textButtonSubmit: 'Aceptar',
                handleClick: () => handleClickClose(),
                oneButtons: true,
                type: 'WARNING',
                open: true
            });
            return;
        }
        const body = {
            id: isId,
            rolePosition: informationPosition.rolePosition,
            chargesUnderSupervision: informationPosition.chargesUnderSupervision.map(function (item) {
                return item['id'];
            }),
            nameProfilePosition: informationPosition.profilePosition,
            attribute: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
            chargeMission: informationPosition.chargeMission,
            immediateBoss: informationPosition.immediateBoss,
            location: informationPosition.location,
            status: informationPosition?.status,
            userEdit: 'Developer',
        };
        setMessage({
            description: edit,
            textButtonSubmit: 'Aceptar',
            handleClick: () => handleClick(body),
            handleClickOut: () => handleClickClose(),
            type: 'WARNING',
            open: true
        })
    };


    const handleClick = (data) => {
        closeModal();
        setOpenEditConfirm(false)
        const edit = async () => {
            const response = await updateProfile(data)
            if (response?.status > 200 && response?.status < 399) {
                setMessage({
                    description: 'La información ha sido editada',
                    textButtonSubmit: 'Aceptar',
                    handleClick: () => handleClickOut(),
                    oneButtons: true,
                    type: 'SUCCESS',
                    open: true
                })
            } else if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
                setMessage({
                    description:  response?.data?.detail ? response?.data?.detail :`Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
                    textButtonSubmit: 'ACEPTAR',
                    handleClick: () => handleClickClose(),
                    oneButtons: true,
                    type: 'WARNING',
                    open: true
                })
            } else {
                setMessage({
                    description : response?.data?.detail
                    ? response?.data?.detail :`Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
                    textButtonSubmit: 'ACEPTAR',
                    handleClick: () => handleClickClose(),
                    oneButtons: true,
                    type: 'WARNING',
                    open: true
                })
            }
        }

        edit();
    };


    return (
        <>
            <ConfirmDialog
                open={confirm.open}
                body={confirm.question}
                handleClickOut={confirm.handleClickOut}
                handleClick={confirm.handleClick}
            />

            <form style={{
                width: 'auto',
                marginTop: '20px',
                marginRight: '15px',
                marginLeft: '15px',
            }}
            >
                <Typography component='h1' variant='h4' style={{ textAlign: 'center' }}>
                    <div className={classes.iconCreate}>
                        <NoteAddIcon fontSize="large" />
                        &nbsp;Editar
                    </div>
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={4}>
                        <SelectPosition
                            label={'Perfil del cargo'}
                            name={'profilePosition'}
                            onChange={onChangeGeneral}
                            value={informationPosition.profilePosition}
                            error={inputsValidation.profilePosition}
                            message={'Este campo es obligatorio'}
                            maper={{ array: charges, value: 'id', show: 'denomination' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <SelectPosition
                            label={"Rol del cargo"}
                            name={"rolePosition"}
                            onChange={onChangeGeneral}
                            value={informationPosition.rolePosition}
                            error={inputsValidation.rolePosition}
                            message={'Este campo es obligatorio'}
                            maper={{ array: (_.sortBy(maestras?.rolDecargo, [function (o) { return o; }])), key: IdKey.generate() }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <SelectPosition
                            label={'Ubicación'}
                            name={"location"}
                            onChange={onChangeGeneral}
                            value={informationPosition.location}
                            error={inputsValidation.location}
                            message={'Este campo es obligatorio'}
                            maper={{ array: location, key: IdKey.generate() }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <SelectPosition
                            label={'Jefe inmediato'}
                            name={"immediateBoss"}
                            onChange={onChangeGeneral}
                            value={informationPosition.immediateBoss}
                            error={inputsValidation.immediateBoss}
                            message={'Este campo es obligatorio'}
                            maper={{ array: charges, key: IdKey.generate(), value: 'id', show: 'denomination' }}
                        />

                        <FormControl fullWidth style={{ marginTop: 15 }}>
                            <Autocomplete
                                multiple

                                name="chargesUnderSupervision"
                                className={classes.dropdownMultiple}
                                options={_.sortBy(charges, (o) => o.denomination)}
                                value={informationPosition.chargesUnderSupervision}
                                onChange={(e, newval, reason) => {
                                    validateSingle('chargesUnderSupervision', newval);
                                    setInformationPosition({ ...informationPosition, chargesUnderSupervision: newval });
                                }}
                                error={inputsValidation.chargesUnderSupervision}
                                getOptionLabel={(option) => titleCase(option.denomination)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Cargos bajo supervisión"
                                        placeholder="Empleado ABC"
                                    // error={inputsValidation.chargesUnderSupervision}
                                    // helperText = {inputsValidation.chargesUnderSupervision}
                                    />
                                )}
                            />
                            {/* <FormHelperText  error={inputsValidation.chargesUnderSupervision}>
                                {inputsValidation.chargesUnderSupervision &&
                                    'Debe seleccionar 1 cargo obligatorio'}
                            </FormHelperText> */}
                        </FormControl>

                    </Grid>
                    <Grid item xs={12} md={12} lg={8}>
                        <FormControl fullWidth>
                            <TextField
                                fullWidth
                                variant="outlined"

                                label="Misión del cargo"
                                multiline
                                className={classes.dropdownMultiple}
                                value={informationPosition.chargeMission}
                                onChange={onChangeGeneral}
                                rows="4"
                                name="chargeMission"
                                error={inputsValidation.chargeMission || minCharacteres || maxCharacteres}
                            />
                            <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                                {inputsValidation.chargeMission &&
                                    'Este campo es obligatorio' || minCharacteres && 'Ingrese minímo 5 caracteres' || maxCharacteres && 'Ingrese máximo 250 caracteres'}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12}>
                        <MUIEditor
                            editorState={editorState}
                            name="texteditorControl"
                            config={editorConfig}
                            onChange={onChangeValue}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={3} style={{ flexFlow: 'row-reverse' }}>
                    <Grid item xs={12} sm={6}>
                        <BorderRedButton onClick={cancelConfirm}>CANCELAR</BorderRedButton>&nbsp;&nbsp;
                        <ColorButton onClick={onClickSave}> GUARDAR </ColorButton>&nbsp;&nbsp;
                        <ModalConfirm
                            description={message.description}
                            textButtonSubmit={message.textButtonSubmit}
                            handleClick={message.handleClick}
                            handleClickOut={message.handleClickOut}
                            oneButtons={message.oneButtons}
                            type={message.type}
                            open={message.open}
                        />
                    </Grid>
                </Grid>
            </form>
        </>
    );
};

export default CreatePosition;
